// extracted by mini-css-extract-plugin
module.exports = {"columns":"_132J6x-0zgiR2a6FCuDX","column":"_206UyvzI0K6nX-w_VfGa","matches":"_3Wen9NAe6kbskfkAPsNj","match-droppable-column":"_2vJGII59SKmpQ7gI7mD-"};